import React from "react"

import CategoryPage from "../components/category"

const Category = () => (
    <CategoryPage tagType="face" />
)

export default Category
